import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Sparkles } from "lucide-react";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("pending");
  const [tries, setTries] = useState(0);
  const { refresh } = useAuth();

  useEffect(() => {
    if (!sessionId) return;
    let cancelled = false;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (cancelled) return;
        setStatus(data.payment_status);
        if (data.payment_status === "paid") { refresh(); return; }
      } catch {}
      if (!cancelled && tries < 20) setTimeout(() => setTries((t) => t + 1), 2000);
    };
    poll();
    return () => { cancelled = true; };
  }, [sessionId, tries, refresh]);

  return (
    <div className="min-h-screen flex items-center justify-center px-6">
      <div className="glass rounded-3xl p-12 max-w-xl text-center">
        <div className="w-16 h-16 mx-auto rounded-full bg-sage/15 flex items-center justify-center">
          <Sparkles size={26} className="text-sage" />
        </div>
        {status === "paid" ? (
          <>
            <h1 className="font-display text-4xl text-navy mt-6" data-testid="pay-success-title">Welcome to Premium.</h1>
            <p className="text-navy/70 mt-3">Your kindness helps us keep Wholesome real and thoughtful. Enjoy deeper insights, unlimited messaging and more.</p>
          </>
        ) : (
          <>
            <h1 className="font-display text-4xl text-navy mt-6" data-testid="pay-pending-title">Almost there…</h1>
            <p className="text-navy/70 mt-3">We're confirming your payment. This usually takes a moment.</p>
          </>
        )}
        <Link to="/app" data-testid="pay-back" className="mt-8 inline-flex btn-pill bg-navy text-cream-100 hover:bg-navy-600">Back to Wholesome</Link>
      </div>
    </div>
  );
}
